import {
    EXTRA_UPLOAD_CONFIRMATION_NEEDED,
    EXTRA_UPLOAD_CONFIRMATION_NOT_NEEDED,
} from '../actions/fileUploads';

const extraUploadConfirmationNeeded = (state = false, action = undefined) => {
    switch (action.type) {
        case EXTRA_UPLOAD_CONFIRMATION_NEEDED:
            return true;
        case EXTRA_UPLOAD_CONFIRMATION_NOT_NEEDED:
            return false;
        default:
            return state;
    }
};

export default extraUploadConfirmationNeeded;
